"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroupsFromProperties = void 0;
const constants_1 = require("../constants");
const types_1 = require("../types");
const createGroupsFromProperties = (eventProperties) => {
    var _a, _b, _c, _d, _e, _f;
    const groups = {};
    if ('companyId' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.COMPANY_ID] = (_a = eventProperties.companyId) !== null && _a !== void 0 ? _a : constants_1.ANALYTICS_UNKNOWN;
    }
    if ('companyName' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.COMPANY_NAME] = (_b = eventProperties.companyName) !== null && _b !== void 0 ? _b : constants_1.ANALYTICS_UNKNOWN;
    }
    if ('country' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.COUNTRY] = (_c = eventProperties.country) !== null && _c !== void 0 ? _c : constants_1.ANALYTICS_UNKNOWN;
    }
    if ('osName' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.OS_NAME] = (_d = eventProperties.osName) !== null && _d !== void 0 ? _d : types_1.AnalyticsOsNameEnum.OTHER;
    }
    if ('platformName' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.PLATFORM_NAME] =
            (_e = eventProperties.platformName) !== null && _e !== void 0 ? _e : constants_1.ANALYTICS_UNKNOWN;
    }
    if ('projectId' in eventProperties) {
        groups[types_1.AnalyticsEventGroupEnum.PROJECT_ID] = (_f = eventProperties.projectId) !== null && _f !== void 0 ? _f : constants_1.ANALYTICS_UNKNOWN;
    }
    return groups;
};
exports.createGroupsFromProperties = createGroupsFromProperties;
